/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsCancelRun } from "../../funcs/llmEvalsCancelRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CancelEvalRunRequest$inboundSchema,
};

export const tool$llmEvalsCancelRun: ToolDefinition<typeof args> = {
  name: "llm-evals-cancel-run",
  description: `Cancel an eval run

Requests cancellation for a queued or running eval run.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsCancelRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
